<template>
  <div class="admin-times-container">
    <div class="admin-times-heading text-center collapsed" :class="admin_times.length ? 'clickable' : ''" data-toggle="collapse" data-target="#admin-times-body">
      <h5 v-if="hasAdminTimes()" class="mb-0 text-black-50"><i class="fa"></i> {{transEdit('admin-times-for-month')}} ({{admin_times.length}} st, {{transEdit('sum').toLowerCase()}}: {{
          numberFormat(admin_times_sum)}} timmar)
      </h5>
      <h5 class="mb-0 text-black-50" v-else>{{transEdit('no-admin-time-month')}}</h5>
    </div>
    <div class="admin-times-body collapse" id="admin-times-body">
      <div v-for="admin_time in admin_times" class="d-flex flex-fill justify-content-between border-top pt-2 pb-2 flex-column flex-md-row">
        <div class="">{{admin_time.date}}</div>
        <div class="text-md-right pr-md-4">{{numberFormat(admin_time.amount)}} timmar</div>

        <div>
          <button class="btn btn-outline-primary btn-sm" @click="showDeleteAdminTimeModal(admin_time)"><i class="fa fa-search"></i> {{transEdit('show')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "therapist-dash-admin-time-list",
  props: ['date', 'route_admin_time', 'do_refresh', 'locked'],
  data: function () {
    return {
      admin_times: [],
      admin_times_sum: 0,
    }
  },
  watch: {
    date: function (newDate, oldDate) {
      this.fetchNewAdminTimes(newDate);
    },
  },
  methods: {
    refresh() {
      this.fetchNewAdminTimes(this.date);
    },
    canDeleteExpenditure: function (date) {
      let tempDate = new Date();
      tempDate = new Date(tempDate.getFullYear(), tempDate.getMonth(), 1);
      let inputDate = new Date(date);

      return true;
    },
    showDeleteAdminTimeModal: function (admin_time) {
      let info = {};
      info.showButton = !this.locked;
      info.date = admin_time.date;
      info.registeredDate = moment(admin_time.created_at).format('YYYY-MM-DD HH:mm');
      info.amount = this.numberFormat(admin_time.amount);
      info.id = admin_time.id;

      this.$eventHub.$emit('therapist-delete-admin-time', info)
    },
    numberFormat: function (number) {
      return window.number_format(number);
    },
    hasAdminTimes: function () {
      return this.admin_times.length > 0;
    },
    fetchNewAdminTimes: function (date) {
      date = date.getYMD();
      let self = this;

      axios.get(this.$portalUrl(self.route_admin_time), {
        params: {
          date: date,
        }
      })
          .then(function (response) {
            let tempSum = 0;
            response.data.forEach(function (admin_time) {
              tempSum += admin_time.amount;
            });

            self.admin_times_sum = tempSum;
            self.admin_times = response.data;
          })
          .catch(function (error) {
          });
    },
  },
  mounted () {
    this.refresh();
  }
}
</script>

<style scoped>

</style>
